import { render, staticRenderFns } from "./NewSub.vue?vue&type=template&id=65b4f998&scoped=true&"
import script from "./NewSub.vue?vue&type=script&lang=js&"
export * from "./NewSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4f998",
  null
  
)

export default component.exports